import { createContext } from "react"
import type { User } from "@nova-ai/shared"

import { useUser } from "../services/use-auth"

export type AuthContextType = {
  user: User | null
  isLoading: boolean
  error: string | null
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined)

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { data: user, isLoading, error } = useUser()

  return (
    <AuthContext.Provider
      value={{
        user: user ?? null,
        isLoading,
        error: error instanceof Error ? error.message : null,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}
